/* eslint-disable no-unused-vars */
import React, { useEffect, useMemo, useRef } from 'react';

import PropTypes from 'prop-types';
import { useLocation, useParams, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from '../../hooks/useQuery';

import {
  createOnboardingSubmission,
  getOnboardingById,
  getOnboardingTemplates,
} from '../../data/store/onboarding/onboardingActions';

import { Layout } from 'antd';

import OnboardingSideBar from '../Onboarding/OnboardingSideBar';
import OnboardingCategory from '../Onboarding/OnboardingCategory';
import CategoryItem from '../Onboarding/CategoryItem';
import { adviseList } from '../Onboarding/data/advise-list';
import { adviseScheemas } from '../Onboarding/data/advise-scheemas';
import { getAdviseElement } from '../Onboarding/data/advise-dictionary';

const OnboardingCreateEdit = ({ theme, currentLang }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { search, pathname } = useLocation();
  const dispatch = useDispatch();
  const { onboardingId } = useParams();
  const query = useQuery(search);
  
  const userId = query.get('account-id');
  const code = query.get('code');
  const category = query.get('category');
  const subCategory = query.get('sub-category');

  const { onboardingTemplates, onboardingById } = useSelector(
    (state) => state.onboardingReducer,
  );
  const getPath = () => {
    return adviseList.find(i => i.code === code)?.path;
  };

  useEffect(() => {
    if(!onboardingTemplates) {
      dispatch(getOnboardingTemplates({path: getPath(), lang: currentLang}));
    }
  }, []);
  

  const getAdvise = (code) => {
    return adviseList.find(i => i.code === code);
  };

  // useEffect(() => {
  //   return () => {
  //     if (onboardingById?.editing_at) {
  //       dispatch(stopOnboardingEdit(onboardingById?.id));
  //     }
  //     dispatch(clearOnboardingFormById());
  //   };
  // }, [code]);
  

  useEffect(() => {
    if (onboardingId && onboardingId !== 'new' && !onboardingById) {
      dispatch(getOnboardingById({id: onboardingId, path: getPath()}));
    } else if (onboardingId === 'new') {
      dispatch(
        createOnboardingSubmission({
          account_id: +userId,
          path: getAdvise(code)?.path,
        }),
      );
    }
  }, [onboardingId]);

  const categoryNavRef = useRef({ onboardingId: null, queryKey: null });

  useEffect(() => {
    if (!onboardingId || onboardingId === 'new') {
      return;
    }
    const queryKey = `${category ?? ''}|${subCategory ?? ''}`;
    const snap = categoryNavRef.current;

    if (snap.onboardingId !== onboardingId) {
      snap.onboardingId = onboardingId;
      snap.queryKey = queryKey;
      return;
    }

    if (snap.queryKey !== queryKey) {
      snap.queryKey = queryKey;
      dispatch(getOnboardingById({id: onboardingId, path: getPath()}));
    }
  }, [onboardingId, category, subCategory, dispatch]);

  useEffect(() => {
    if (onboardingById && onboardingId === 'new' && onboardingById.id) {
      const newPathname = pathname.replace('/new', `/${onboardingById.id}`);
      history.replace({
        pathname: newPathname,
        search: search,
      });
    }
  }, [onboardingById, onboardingId, pathname, search, history]);

  // const rules = [
  //   {
  //     new_keys: { size: '50%' },
  //   },
  //   {
  //     new_keys: {
  //       dependence: {
  //         input_id: '7264f013-1653-11f1-8976-9280707bef5d',
  //         value: 'Other (describe)',
  //       },
  //     },
  //   },
  //   {
  //     new_keys: {
  //       dependence: {
  //         input_id: '7286f27d-1653-11f1-8976-9280707bef5d',
  //         value: 'Other (describe)',
  //       },
  //     },
  //   },
  //     new_keys: { display: 'table' },
  //   },
  // ];

  const onboardingPoints = useMemo(() => {
    return adviseScheemas.find(i => i.code === code)?.form_element_groups;
  }, [code]);

  const wayPoint = useMemo(() => {
    if (onboardingPoints) {
      const array = [];
      onboardingPoints.forEach((i) => {
        if (i.subCategory.length > 0) {
          i.subCategory.forEach((j) => {
            array.push(j.id);
          });
        } else {
          array.push(i.id);
        }
      });
      return array;
    } else {
      return [];
    }
  }, [onboardingPoints]);
  
  //TODO rework this function
  const validateCategory = useMemo(() => {
    const result = {};

    onboardingPoints.forEach(i => {
      let total = 0;
      let filled = 0;
      let mandatory = 0;
      let filledMandatory = 0;
      if(subCategory?.length) {
        let total = 0;
        let filled = 0;
        let mandatory = 0;
        let filledMandatory = 0;
        i.form_element( j => {
          total += j?.form_element?.length;
          const required = j.form_element.filter(el => getAdviseElement(el.code)?.min_number_of_submissions === 1)
        .map(i => ({code: i.code, field_name: i?.field_name}));
        mandatory += required.length;
        if(onboardingById) {
          filledMandatory += required.filter( req => (req.field_name === '' &&
            Object.hasOwn(onboardingById, 'attachment')) || (onboardingById?.[req.field_name] !== undefined)).length;

            const totalArray = i.form_element.map(k => getAdviseElement(k.code)?.field_name ?? null ).filter(i => i !== null);
            totalArray.forEach(k => {
              if(Object.hasOwn(onboardingById, k) && onboardingById?.[k] !== undefined && onboardingById?.[k] !== null) {
                filled ++;
              }
            });
        }
      });
      } else {
        total += i.form_element?.length;
        const required = i.form_element.filter(el => getAdviseElement(el.code)?.min_number_of_submissions === 1)
        .map(i =>({code: i.code, field_name: getAdviseElement(i.code)?.field_name}));
        mandatory += required.length;
        if(onboardingById) {
          filledMandatory += required.filter( req => (req.field_name === '' &&
            Object.hasOwn(onboardingById, 'attachment')) || (onboardingById?.[req.field_name] !== undefined)).length;
            
            const totalArray = i.form_element.map(k => getAdviseElement(k.code)?.field_name ?? null ).filter(i => i !== null);
            totalArray.forEach(k => {
              if((Object.hasOwn(onboardingById, k) && onboardingById?.[k] !== undefined && onboardingById?.[k] !== null) || k === '') {
                filled ++;
              }
            });
        }
      }
      result[i.id] = {total, filled, mandatory, filledMandatory};
    });

    return result;
  }, [onboardingPoints, onboardingById]);

  const getItemForCategory = useMemo(() => {
    const data = onboardingPoints?.find((i) => i.id === category);
    return data;
  }, [category, subCategory, onboardingPoints]);

  useEffect(() => {
    if (!onboardingPoints?.length) {
      return;
    }

    const newQuery = new URLSearchParams(search);
    let needsReplace = false;

    const rootCategory = onboardingPoints.find((p) => p.id === category);
    const categoryValid = Boolean(rootCategory);

    if (!categoryValid) {
      newQuery.set('category', onboardingPoints[0].id);
      newQuery.delete('sub-category');
      needsReplace = true;
    } else {
      const subs = rootCategory.subCategory || [];
      if (subs.length > 0) {
        if (subCategory && !subs.some((s) => s.id === subCategory)) {
          newQuery.delete('sub-category');
          needsReplace = true;
        }
      } else if (subCategory) {
        newQuery.delete('sub-category');
        needsReplace = true;
      }
    }

    if (needsReplace) {
      history.replace({
        pathname,
        search: `?${newQuery.toString()}`,
      });
    }
  }, [
    onboardingId,
    code,
    onboardingPoints,
    category,
    subCategory,
    search,
    pathname,
    history,
  ]);

  const handleSelectCategory = (id) => {
    if (id === category) {
      return;
    }
    const newQuery = new URLSearchParams(search);
    newQuery.set('category', id);
    newQuery.delete('sub-category');
    history.replace({
      pathname,
      search: `?${newQuery.toString()}`,
    });
  };

    const getAdviseTemplate = useMemo(() => {
      const path = getPath();
      const tmp = onboardingTemplates?.[path];
      return {name: tmp?.name, description: tmp?.description || ''};
    }, [code, onboardingTemplates]);

    const getNameByCode = (id) => {
      const path = getPath();
      const tmp = onboardingTemplates?.[path];
      return tmp?.items?.find( i => i.code === id)?.description;
    };

  return (
    <Layout className="layout-main onbording-card-wrapper">
      <OnboardingSideBar theme={theme}>
        <div className="onbording-card card-left">
          <div className="onbording-card-fill" style={{ height: 'auto' }}>
            <div className="onbording-step-wrapper">
              <h2 className="onbording-card-title">
                {getAdviseTemplate?.name || ''}
              </h2>
              <p className="onbording-card-description ">
                {getAdviseTemplate?.description || ''}
              </p>
            </div>
          </div>
          <div className="onboarding-category-wrap">
            {onboardingPoints?.map((i) => {
              return (
                <div
                  key={i.id}
                  className={'onboarding-category-item'}
                  onClick={() => handleSelectCategory(i.id)}
                >
                  <CategoryItem
                    name={getNameByCode(i.code)}
                    selected={category === i.id}
                    selectedIndex={onboardingPoints.findIndex(
                      (item) => item.id === category,
                    )}
                    t={t}
                    category={i}
                    validateCategory={validateCategory?.[i.id]}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </OnboardingSideBar>
      <OnboardingCategory
        key={
          onboardingId === 'new'
            ? `new-${userId ?? ''}-${code ?? ''}`
            : String(onboardingId ?? '')
        }
        item={getItemForCategory}
        wayPoint={wayPoint}
        onboardingPoints={onboardingPoints}
        getNameByCode={getNameByCode}
        validateCategory={validateCategory}
      />
    </Layout>
  );
};

export default OnboardingCreateEdit;

OnboardingCreateEdit.propTypes = {
  theme: PropTypes.string,
  currentLang: PropTypes.string,
};
